import { render, staticRenderFns } from "./ButtonDropdown.vue?vue&type=template&id=2c964ed8"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,DropdownMenuList: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/dropdown-menu-list/DropdownMenuList.vue').default,Popover: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/popover/Popover.vue').default})
